// extracted by mini-css-extract-plugin
export var chip = "_g3-0";
export var filterDropdown = "_g3-5";
export var filterItem = "_g3-6";
export var icon = "_g3-1";
export var removeButton = "_g3-3";
export var removeIcon = "_g3-4";
export var separator = "_g3-2";